import * as Sentry from '@sentry/vue';
import {Integrations} from '@sentry/tracing';

export function sentryInit(app:any, router:any) {
    // 2026-5-21 禁用 sentry
    return false;
    Sentry.init({
        app,
        dsn: 'https://adb952a6032046d1b88bbd45a8da39ff@sentry.baijia.com/1614',
        environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router)
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
    });
    app.config.globalProperties.$sentry = Sentry;
}

export function sentryReport(msg:string, data:Record<string, any>) {
    // 2026-5-21 禁用 sentry
    return false;
    const {tags, extra} = data;
    Sentry.captureException(new Error(msg), {tags, extra});
}
